// extracted by mini-css-extract-plugin
export default {"slide":"SliderBannerShort_slide__8eVBb"};